import { type JSX } from 'react';
import { Query as QueryApollo } from '@apollo/client/react/components';

import { IRutinInfo } from '../../../../../Types/RutinInfoType';

import startedRoutinesQuery from './Queries/StartedRoutinesQuery.gql';
import type {
  StartedRoutinesQuery as StartedRoutinesQueryData,
  StartedRoutinesQueryVariables,
  StartedRoutinesQuery_me_startedroutines as IStartedRoutine,
} from './Queries/_QueryTypes/StartedRoutinesQuery';
import { useLogStartedRoutine } from '../../../../Delsystem/_StandardRutin/Mutations/LogStartedRoutineMutation/LogStartedRoutineHook';

interface IQueryProp {
  dbName: string;
  children: (
    loading: boolean,
    startedRoutines: IStartedRoutine[]
  ) => JSX.Element;
}

export const StartedRoutineQuery = (props: IQueryProp) => (
  <QueryApollo<StartedRoutinesQueryData, StartedRoutinesQueryVariables>
    query={startedRoutinesQuery}
    variables={{ dbname: [props.dbName.toLowerCase()] }}
    skip={!props.dbName}
  >
    {({ loading, data }) =>
      props.children(
        loading,
        data && data.me && data.me[0] && data.me[0].startedroutines
          ? data.me[0].startedroutines
          : []
      )
    }
  </QueryApollo>
);

const withLogStartedRoutine =
  (rutinID: number) => (WrappedComponent: any) => (props: any) => {
    useLogStartedRoutine(rutinID);

    return <WrappedComponent {...props} />;
  };

export const withAddStartedRoutine = (rutinInfo: IRutinInfo) =>
  withLogStartedRoutine(rutinInfo.rutinID);

export { IStartedRoutine };
